import React, { useMemo, useState } from 'react';
import Form from '../../../molecules/Form/Form';
import linkedinService from '../../../../services/linkedinService';
import Select from 'react-select';
import Toast from '../../../molecules/Toast';
import Button from '../../../molecules/Button';
import { useForm } from '../../../molecules/Form';
import Field from '../../Field';
import { StyledLoginWithLinkedinModal } from './DetailsTab.style';
import { handleJsonFileUpload } from '../../../../helpers/common';
import { Link, useLocation } from 'react-router-dom';

const options = [
  { value: 'ES', label: 'Spain' },
  { value: 'IT', label: 'Italy' },
  { value: 'CA', label: 'Canada' },
  { value: 'HR', label: 'Croatia' },
  { value: 'HK', label: 'Hong Kong' },
  { value: 'SE', label: 'Sweden' },
  { value: 'AU', label: 'Australia' },
  { value: 'JP', label: 'Japan' },
  { value: 'BE', label: 'Belgium' },
  { value: 'FR', label: 'France' },
  { value: 'DE', label: 'Germany' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'PL', label: 'Poland' },
  { value: 'US', label: 'United States of America (USA)' },
];

const LoginWithLinkedinModal = ({ onClose, setLinkedingLogin }) => {
  const [form] = useForm();
  const location = useLocation();
  const [value, setValue] = useState(options.find(c => c.value === 'US'));
  const [loading, setLoading] = useState(false);
  const [jsonData, setJsonData] = useState(null);
  const changeHandler = value => {
    setValue(value);
  };

  const handleOnDrop = file => {
    handleJsonFileUpload(file, parsed => setJsonData(parsed), form);
  };

  async function handleSubmit(e) {
    setLoading(true);

    try {
      const payload = {
        // email: e?.email,
        // password: e?.password,
        cookies: jsonData,
        country: value?.value,
      };
      const res = await linkedinService.linkedinLogin(payload);

      if (res.success) {
        Toast({
          type: 'success',
          message: res.message || 'LinkedIn account connected successfully',
        });
        if (location?.pathname === '/find-leads') {
          setLinkedingLogin(false);
        }
        if (location?.pathname === '/profile') {
          onClose();
        }
      }
    } catch (error) {
      Toast({
        type: 'error',
        // message: error.message,
        message: 'Something went wrong',
      });
    } finally {
      setLoading(false);
    }
  }
  return (
    <StyledLoginWithLinkedinModal>
      <ul className="list">
        <li>
          Install the Chrome extension &nbsp;
          <Link
            to="https://chromewebstore.google.com/detail/export-cookie/mihpbjkemmmcijofboelgleihmalpaba?authuser=0&hl=de"
            target="_blank"
            rel="noreferrer">
            click here
          </Link>
        </li>
        <li>Export the LinkedIn cookie file using the extension </li>
        <li>Upload the cookie file to Houdiny</li>
        <li>Select your region</li>
        <li>Login will complete successfully</li>
      </ul>

      <span className="instruction-text">
        Instruction video: &nbsp;
        <Link
          to="https://www.loom.com/share/68898964ca414caebeada8688dfc8d68?sid=6e9aa7f0-c64a-494e-8b51-0c7ba50f4698"
          target="_blank"
          rel="noreferrer">
          Watch here
        </Link>
      </span>

      <Form form={form} onSubmit={handleSubmit}>
        {/* <div className="input-wrapper">
          <Form.Item
            type="email"
            label="Email"
            name="email"
            placeholder="Enter Email"
            rules={[
              {
                required: true,
                message: 'Email is required',
              },
            ]}>
            <Field />
          </Form.Item>
          <Form.Item
            type="password"
            label="Password"
            name="password"
            placeholder="Enter password..."
            rules={[
              {
                required: true,
              },
            ]}>
            <Field />
          </Form.Item>
        </div> */}
        <Form.Item
          type="json"
          rounded
          name="csvfile"
          uploadTitle="Upload JSON"
          disc="Drag & Drop or choose file to upload Limit 200MB per file •JSON"
          fileSize={20}
          icon
          accept=".json,application/json"
          onChange={handleOnDrop}
          rules={[
            {
              required: true,
              message: 'File is required to continue',
            },
          ]}>
          <Field />
        </Form.Item>
        <div className="form-hook-country-field">
          <span className="label">Country</span>
          <Select
            classNamePrefix="react-select"
            options={options}
            value={value || null}
            onChange={changeHandler}
            menuPosition="fixed"
            formatOptionLabel={country => (
              <div className="flag-holder">
                <img src={`https://flagcdn.com/w40/${country.value.toLowerCase()}.png`} alt={country.label} />
                <span>{country.label}</span>
              </div>
            )}
          />
        </div>
        <div className="btn-holder">
          <Button loader={loading} width="250px" type="submit" disabled={loading}>
            Continue
          </Button>
        </div>
      </Form>
    </StyledLoginWithLinkedinModal>
  );
};

export default LoginWithLinkedinModal;
